import React, { useContext } from 'react';

import { CompanyContext } from 'common/containers/CompanyContainer';
import AdminSettingsHeader from 'common/subdomain/admin/AdminSettings/AdminSettingsHeader';
import { RoutePermissions } from 'common/util/permissions';

import AdminSettingsSidebarLink from './AdminSettingsSidebarLink';
import IdeasConfigurationContainer from './v2/containers/IdeasConfigurationContainer';

import 'css/components/subdomain/admin/_AdminFieldsSettingsContainer.scss';

import type { Company } from 'common/api/endpoints/companies';

type FieldsSidebarLink = {
  label: string;
  urlSuffix: keyof typeof RoutePermissions.adminSettings.postFields;
  featureFlag?: string;
};

type Props = {
  children: React.ReactNode;
};

const AdminFieldsSettingsContainer = ({ children }: Props) => {
  const company = useContext<Company>(CompanyContext);

  const SidebarLinks: FieldsSidebarLink[] = [
    {
      label: company.featureAllowlist.includes('idea-database')
        ? 'Post & Idea Fields'
        : 'Post Fields',
      urlSuffix: 'post-fields',
    },
    {
      label: 'Company Fields',
      urlSuffix: 'company-fields',
    },
    {
      label: 'Statuses',
      urlSuffix: 'statuses',
      featureFlag: 'idea-database',
    },
    {
      label: 'Themes',
      urlSuffix: 'themes',
      featureFlag: 'idea-database',
    },
  ];

  const filteredSidebarLinks = SidebarLinks.filter(({ featureFlag }) => {
    if (!featureFlag) {
      return true;
    }

    return company.featureAllowlist.includes(featureFlag);
  });

  return (
    <IdeasConfigurationContainer>
      <div className="adminFieldsSettingsContainer">
        <AdminSettingsHeader
          title="Data"
          subheading="Configure data used across your workspace."
          learnMoreLink="https://help.canny.io/en/articles/6329585-customizing-fields"
        />
        <div className="settingsContainer">
          <div className="settingsSidebar">
            {filteredSidebarLinks.map(({ label, urlSuffix }) => (
              <AdminSettingsSidebarLink
                key={urlSuffix}
                requiredPermissions={RoutePermissions.adminSettings.postFields[urlSuffix]}
                to={`/admin/settings/fields/${urlSuffix}`}>
                {label}
              </AdminSettingsSidebarLink>
            ))}
          </div>
          <div className="settingsContent">{children}</div>
        </div>
      </div>
    </IdeasConfigurationContainer>
  );
};

export default AdminFieldsSettingsContainer;
